import React from "react";

class Collapsable extends React.Component {
    render() {
        let colSpan = this.props.colSpan;
        if(!colSpan) {
            colSpan = 1;
        }

        if(this.props.collapsed) {
            return null;
        }

        return (
            <td colSpan={colSpan}>{this.props.children}</td>
        );
    }
}

export default Collapsable;